import React from "react";
import VideoThumbnail from "../Thumbnails";
import "./styles.css";

const VideoList = ({ videos, currentVideo, onSelectVideo }) => {
  return (
    <div className="video-list-container">
      <h3 className="video-list-title">Vídeos Disponíveis</h3>
      <div className="video-list-grid">
        {videos.map((video, index) => (
          <VideoThumbnail
            key={index}
            video={video}
            isActive={currentVideo?.original === video.original}
            onClick={() => onSelectVideo(video)}
          />
        ))}
      </div>
    </div>
  );
};

export default VideoList;
